import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const PROMO_END_ISO = "2026-06-30T23:59:59+06:30";

function getCountdown() {
  const diff = new Date(PROMO_END_ISO).getTime() - Date.now();
  if (diff <= 0) return null;
  const days = Math.floor(diff / 86400000);
  return { days };
}

export default function PromoBanner() {
  const [countdown, setCountdown] = useState(getCountdown());

  useEffect(() => {
    const t = setInterval(() => setCountdown(getCountdown()), 60 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="promo-banner"
      className="bg-[#0F4E2A] text-white border-b border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-center gap-x-5 gap-y-1 text-[13px] flex-wrap tracking-wide">
        <span className="inline-flex items-center gap-2">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#B5DC57]" />
          <span className="font-semibold uppercase text-xs tracking-[0.18em]">Tax Season Offer</span>
        </span>
        <span className="text-white/40">|</span>
        <span className="inline-flex items-baseline gap-2 tabular-nums">
          <span className="line-through text-white/50 text-xs">၃၅,၀၀၀</span>
          <span className="font-semibold">၃၀,၀၀၀ ကျပ်</span>
        </span>
        <span className="text-white/40">|</span>
        <span className="text-[#B5DC57] font-semibold">၅,၀၀၀ ကျပ် Save</span>
        {countdown && (
          <>
            <span className="text-white/40 hidden sm:inline">|</span>
            <span className="inline-flex items-center gap-1.5 text-white/80 text-xs">
              <Clock className="w-3 h-3" />
              <span className="tabular-nums">Ends 30 Jun 2026 · {countdown.days} days left</span>
            </span>
          </>
        )}
      </div>
    </div>
  );
}
